import XSvg from '@/shared/assets/images/X.svg'
import { IJobApplication } from "@/shared/api/employment"
import { FC } from "react"
import { DropdownItem } from "@/shared/ui/dropdown-item"
import { useUpdateJobApplicationModal } from "@/features/update-job-application"
import { useAppDispatch } from '@/shared/lib/redux'
import { fetchJobApplications } from '../../model'

interface RejectApplicationProps {
    application: IJobApplication
}

export const RejectApplication: FC<RejectApplicationProps> = ({ application }) => {
    const { openRejectJobApplicationModal } = useUpdateJobApplicationModal()
    const dispatch = useAppDispatch()

    const onApprove = () => {
        dispatch(fetchJobApplications())
    }

    return (
        <DropdownItem 
            onClick={() => openRejectJobApplicationModal(application, onApprove)}
            icon={XSvg} 
            label={"Отклонить"}        
        />
    )
}